<template>
  <div class="search-card search-card--set">
    <ImgComponent :img="data.img" class="search-card__img" width="100" height="100" contain />
    <div class="search-card__info">
      <span class="search-card__title">{{ data.title }}</span>
      <span class="search-card__subtitle">12 товаров</span>
    </div>
    <button class="btn btn--sm btn--main-hollow">
      <RemixIconComponent category="finance" name="shopping-cart-line" />
    </button>
  </div>
</template>

<script>
import RemixIconComponent from "components/RemixIconComponent.vue";
import ImgComponent from "components/ImgComponent.vue";

export default {
  name: "SearchProductCardComponent",
  props: {
    data: Object,
  },
  components: { ImgComponent, RemixIconComponent },
};
</script>
